export interface State {
  cancelText: string
  confirmText: string

  confirmModalActived: boolean
  confirmModalText: string
  callback: Function

  useSingleButton: boolean
  singleButtonWidth: string
}

const state = (): State => ({
  cancelText: 'キャンセル',
  confirmText: 'OK',

  confirmModalActived: false,
  confirmModalText: '',
  callback: () => {},

  useSingleButton: false,
  singleButtonWidth: '105px',
})

export default state
